<template>
  <div>
    <div>
      <v-layout wrap>
        <v-flex xs9 class="pl-2">
          <h5 style="color:#66a6fe">
            Chatday By
            <img src="/static/img/readyplanet.png" style="height: 25px" />
            <v-chip color="red" class="white--text" disabled small>{{ $t('New') }}</v-chip>
          </h5>
        </v-flex>
        <v-flex class="text-xs-right">
          <div
            class="btn-floating btn-outline-red"
            style="margin-left:5px;margin-bottom: 5px;"
            v-if="!isEdit"
            @click="isEdit = true"
          >
            <i class="fa fa-pencil-alt middle"></i>
          </div>
        </v-flex>
        <v-flex xs12 class="pl-2">
          <ul class="list-group vertical-steps">
            <li class="list-group-item">
              สร้างแชทบอทได้บนเว็บไซต์ เพียงลงทะเบียนเปิดบัญชีกับระบบ Chatday สมัครฟรีวันนี้
              <div>
                <v-btn
                  class="py-2"
                  color="primary"
                  depressed
                  style="display: inline-block"
                  href="https://www.readyplanet.com/17331353/readyplanet-marketing-platform?utm_source=zwiz&utm_medium=referral&utm_campaign=<chatday>"
                  target="_BLANK"
                >{{ $t('Register CHATDAY') }}</v-btn>
              </div>
            </li>
            <li class="list-group-item">
              <div class="form-control" :class="{ 'has-error': errors.has('token') }">
                <label for="text">{{ $t('Token') }}</label>
                <div v-if="isEdit">
                  <textarea
                    class="form-control"
                    rows="5"
                    maxlength="600"
                    v-model="token"
                    style="resize:vertical;min-height: 90px"
                    :data-vv-as="$t('Token')"
                    name="token"
                    v-validate="{ required: true }"
                    :placeholder="'Token'"
                  ></textarea>

                  <span class="text-error" v-if="errors.has('token')">
                    {{
                    errors.first('token')
                    }}
                  </span>
                </div>
                <div v-else>
                  <h6 style="word-break: break-all;">{{ token ? token : '-' }}</h6>
                </div>
                <div class="text-xs-center" style="margin-top: 15px;" v-if="isEdit">
                  <a href="javascript:void(0);" class="btn btn-outline-gray" @click="cancelEdit">
                    {{
                    $t('cancel')
                    }}
                  </a>
                  <a href="javascript:void(0);" class="btn" @click="saveEdit">{{ $t('Save') }}</a>
                </div>
              </div>
            </li>
            <li class="list-group-item" v-if="token">
              <div>
                <label for>Webhook Url</label>
                <textarea
                  class="form-control"
                  style="resize: vertical;min-height: 90px;background: #eee"
                  onclick="this.select()"
                  readonly="true"
                >
                    https://zwizai.herokuapp.com/webhookreadyplanet
                    </textarea>
              </div>
            </li>
          </ul>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'

export default {
  data() {
    return {
      isEdit: false,
      token: ''
    }
  },
  mounted() {
    this.token = this.selectedBot.chatday_token
    if (this.token == null || this.token == '') {
      this.isEdit = true
    }
  },
  computed: {
    ...mapGetters({
      currentLang: 'currentLang',
      selectedBot: 'selectedBot'
    })
  },
  methods: {
    cancelEdit() {
      this.token = this.selectedBot.chatday_token
      this.isEdit = false
    },
    async saveEdit() {
      let result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }

      let status = await this.checkChatdayToken()
      if (status) {
        this.$swal.fire({
          title: this.$t('Successfully'),
          type: 'success'
        })
        this.isEdit = false
      } else {
        this.$swal.fire({
          title: this.$t('Unsuccessful'),
          type: 'error'
        })
      }
    },
    checkChatdayToken() {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          pageid: vm.selectedBot.pageid,
          chatday_token: vm.token
        }
        api.checkChatdayToken(data, (error, response) => {
          if (error) reject(error)

          if (response.responsecode == 200 && response.status == 'pass') resolve(true)
          else resolve(false)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/Chatday.vue